package com.narbase.letsgo.web.models.linkshare

import com.narbase.letsgo.dto.EnumDtoName
import com.narbase.letsgo.dto.core.EnumPersistenceName

enum class SharedLocationType(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    CURRENT_LOCATION,
    FAVORITE_POINT,
    LOCATION,
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class TopLinksSortBy(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    CLICKS,
    RIDES_COMPLETED
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class LinkShareDateRange(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    THIS_WEEK,
    THIS_MONTH,
    PAST_3_MONTHS,
    CUSTOM
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}
